module.exports = __webpack_public_path__ + "img/FINANCEPR5.8f94ed86.png";